import React, { useEffect, useState } from "react";
import HeadHouseHold from "../../../../assets/svg/head-houseHold.svg";
import HouseholdIncome from "../../../../assets/svg/household-income.svg";
import PropertyType from "../../../../assets/svg/property-type.svg";
import ChildrenAge from "../../../../assets/svg/children-age.svg";
import HomeOwnership from "../../../../assets/svg/homeOwnership.svg";
import ESP from "../../../../assets/svg/ESP.svg";
import { FaCheckCircle } from "react-icons/fa";
import AtriumApi from "../../../../api";

const Demographic = ({ userId }) => {
  const [data, setData] = useState([]);
  const [features, setFeatures] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDemographics = async () => {
      try {
        const res = await AtriumApi.get(`/v2/demographics/person/${userId}`);
        const demographics = res.data?.data?.demographics || {};

        const apiData = [
          {
            icon: <img src={HeadHouseHold} alt="head-houseHold" />,
            label: "Head of Household Age",
            value: demographics.ageOfHeadOfHousehold,
          },
          {
            icon: <img src={HouseholdIncome} alt="household-income" />,
            label: "Household Income",
            value: demographics.estimatedHouseholdIncome,
          },
          {
            icon: <img src={PropertyType} alt="property-type" />,
            label: "Type Of Property",
            value: demographics.typeOfProperty,
          },
          {
            icon: <img src={ChildrenAge} alt="children-age" />,
            label: "Age of Children",
            value: demographics.ageOfChildren,
          },
          {
            icon: <img src={HomeOwnership} alt="homeOwnership" />,
            label: "Home Ownership",
            value: demographics.homeOwnership,
          },
          {
            icon: <img src={ESP} alt="ESP" />,
            label: "ESP",
            value: demographics.ESP,
          },
        ];

        setData(apiData);
        setFeatures(demographics.keyFeatures || []);
      } catch (error) {
        console.error("Error fetching demographics:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDemographics();
  }, [userId]);

  if (loading) return <p>Loading demographics...</p>;

  // 👇 Check if all values are empty/null
  const hasData =
    data.some((item) => item.value && item.value !== "") ||
    (features && features.length > 0);

  if (!hasData) {
    return (
      <p className="text-center text-gray-500 dark:text-gray-300">
        No demographic match available
      </p>
    );
  }

  return (
    <div className="mt-6 mb-2">
      <div className="grid md:grid-cols-2 grid-cols-1 gap-6">
        {data.map(
          (item, index) =>
            item.value && (
              <div key={index} className="flex items-start gap-4 border-b pb-4">
                <div className="bg-[#F4F7FE] dark:bg-[#0b1437] p-3 rounded-full">
                  {item.icon}
                </div>
                <div>
                  <p className="text-[#707EAE] dark:text-[#A3AED0] text-[12px]">
                    {item.label}
                  </p>
                  <p className="text-[16px] font-[600] text-[#2B3674] dark:text-white">
                    {item.value}
                  </p>
                </div>
              </div>
            )
        )}
      </div>

      {features.length > 0 && (
        <div className="bg-[#F4F7FE] dark:bg-[#0b1437] p-6 rounded-[20px] shadow-md mt-6">
          <h3 className="text-lg font-semibold text-[#1A1F36] dark:text-white mb-4">
            Key Features
          </h3>
          <div className="grid md:grid-cols-2 gap-y-3">
            {features.map((feature, index) => (
              <div key={index} className="flex items-center gap-2">
                <FaCheckCircle className="text-green-500 " size={22} />
                <span className="text-[16px] text-[#707EAE] ">{feature}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Demographic;
